import { render } from "./Revisie.vue?vue&type=template&id=7268154a&scoped=true&ts=true"
import script from "./Revisie.vue?vue&type=script&lang=ts"
export * from "./Revisie.vue?vue&type=script&lang=ts"

import "./Revisie.vue?vue&type=style&index=0&id=7268154a&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7268154a"]])

export default __exports__